export default "__VITE_ASSET__C3UOu9Jj__"